// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2O4Wc","footer":"ModalError_footer__1SWs0"};